import { useLayoutEffect } from "react";

// Applies the dForms theme to every screen except the login page.
// Wrap a route's element in <ThemeScope>; the login route is never wrapped.
// All theme rules are scoped to html.df-theme, which is set here while a
// wrapped route is shown (on <html>, so dialogs and toasts rendered outside
// the app root are covered too) and removed when it goes away. The theme's
// CSS and fonts are loaded on first use, so the login page never loads them.
//
// Until that first load finishes (a moment, once per visit) the page is kept
// hidden, so it never flashes unstyled (for example the header logo at its
// full size). If loading fails or takes over 3 seconds, the page is shown
// anyway.
let stylesPromise = null;
let stylesReady = false;
let mounted = 0;

const show = () => { document.documentElement.style.visibility = ""; };

export default function ThemeScope({ children }) {
    useLayoutEffect(() => {
        const root = document.documentElement;
        if (!stylesPromise) {
            stylesPromise = import("./themeStyles")
                .catch(() => { /* show the page unstyled rather than not at all */ })
                .then(() => { stylesReady = true; });
        }
        mounted += 1;
        root.classList.add("df-theme");
        let timer = null;
        if (!stylesReady) {
            root.style.visibility = "hidden";
            stylesPromise.then(show);
            timer = setTimeout(show, 3000);
        }
        return () => {
            clearTimeout(timer);
            mounted -= 1;
            if (mounted === 0) {
                root.classList.remove("df-theme");
                show();
            }
        };
    }, []);
    return children;
}
